import React from 'react';
import HeaderLogo from '../../../assets/images/logo1.png'
import './PublicHeader.scss';
import { path } from '../../../constants';
import { Link } from 'react-router-dom';
import { MainLogo } from '../../../assets/svg';

export default function PublicHeader() {
  return (
    <div className="auth-navbar">
      <Link to={process.env.REACT_APP_FRONTEND_BASE_URL ?? '#'} target='_blank`'>
      <img alt="logo" src={MainLogo} className="logo" />
      </Link>
      <div className="header-menu-container">
        <Link to='https://care.kalp.studio/support/home' target='_blank`'>
        <div className="header-text">Help</div>
        </Link>
        <Link to={path.PRIVACY_POLICY} className='header-text' target='_blank'>
        <p className="header-tex">Privacy Policy</p>
        </Link>
        <Link to={path.TERMS_AND_CONDITIONS} className='header-text' target='_blank'>
        <p className="header-tex">Terms</p>
        </Link>
      </div>
    </div>
  );
}
